import { escapeHTML } from '../../utils/escape.js';

/**
 * Diálogo de confirmación para las 3 acciones de transición de estado
 * (terminar/cancelar/archivar — Req: Staff Status Transition
 * Actions / Archive Action Restricted to Cancelada or Terminada). Función de
 * render pura: devuelve un string HTML, sin estado ni efectos.
 *
 * El botón de aceptar sigue usando `data-action="reserva-confirm"` (hook de
 * click fijo, sin cambios — `js/admin.js` lo sigue localizando igual que
 * antes) y transporta el id de la reserva pendiente en `data-id`; la acción
 * de transición pendiente (`terminar|cancelar|archivar`) viaja en
 * `data-reserva-action`, reemplazando el viejo `data-status` (2-status
 * arrival model). El mensaje es per-acción y lo compone el llamador
 * (`js/admin.js`), no este componente — mantiene el diálogo genérico y
 * reusable para las 4 acciones.
 */

/**
 * @param {{ id: string, action: 'terminar'|'cancelar'|'archivar', message: string }} params
 * @returns {string} HTML del diálogo de confirmación.
 */
export const ConfirmDialog = ({ id, action, message }) => `
    <div role="alertdialog" aria-modal="true" aria-labelledby="reserva-confirm-title"
        class="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 px-6">
        <div class="bg-base rounded-[2rem] p-8 max-w-sm w-full shadow-2xl">
            <p id="reserva-confirm-title" class="text-sm font-bold text-text-primary text-center mb-8">
                ${escapeHTML(message)}
            </p>
            <div class="flex gap-3">
                <button data-action="reserva-dismiss"
                    class="flex-1 py-4 rounded-2xl border border-border-subtle text-xs font-black uppercase tracking-widest text-text-muted">
                    Cancelar
                </button>
                <button data-action="reserva-confirm" data-id="${escapeHTML(id)}" data-reserva-action="${escapeHTML(action)}"
                    class="flex-1 py-4 rounded-2xl bg-brand text-white text-xs font-black uppercase tracking-widest shadow-lg">
                    Confirmar
                </button>
            </div>
        </div>
    </div>
`;
